import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'

import '../../asset/less/component.css'

import {Button, Col, Form, Input, message, Row, Select, Typography, Upload} from 'antd'
import {EditOutlined, FileAddOutlined, MinusCircleOutlined, PlusOutlined, UploadOutlined} from '@ant-design/icons'

import {createDocument, getDocumentPDF, uploadFile} from '../../api/eversign'
import {deleteArtistContract, getAllArtistContracts, postArtistContract} from '../../api/artistContracts'
import {getAllArtistNames} from '../../api/artistNames'
import {URL_AGREEMENTS} from '../../const'
import {is_admin_user} from "../../app/role";

const {Title} = Typography

@connect((state) => ({
    //decorator, gives component access to the state
    userId: state.user.info.id,
    email: state.user.info.email,
    siderWidth: state.style.siderWidth,
    role: state.user.info.role //'admin'
}))
class NewAgreement extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            signedContracts: [],
            todoContracts: [],
            artists: []
        }
    }

    componentDidMount() {
        if (is_admin_user(this.props)) {
            getAllArtistNames().then((response) => {
                const artists = response.data
                for (const artist of artists) {
                    this.setState({
                        artists: [...this.state.artists, artist]
                    })
                }
            })
        }

        getAllArtistContracts().then((response) => {
            //console.log(response.count)
            for (const contract of response.data.results) {
                let is_signed = false
                is_signed = contract.is_signed_revart && contract.is_signed
                if (is_signed) {
                    getDocumentPDF(contract.hash).then((docPDF) => {
                        contract.pdf = docPDF.data.url
                        this.state.signedContracts.push(contract)
                        this.setState({signedContracts: this.state.signedContracts})
                    })
                } else {
                    this.state.todoContracts.push(contract)
                }
            }
            this.setState(
                {
                    signedContracts: this.state.signedContracts,
                    todoContracts: this.state.todoContracts
                },
                () => {
                    // console.log(this.state.signedContracts)
                    // console.log(this.state.todoContracts)
                }
            )
        })
    }

    capitalizeName(name) {
        return name.replace(/\b(\w)/g, (s) => s.toUpperCase())
    }

    onDeleteButtonClick = (contract_id) => {
        deleteArtistContract(contract_id)
            .then(() => {
                message.success('Delete successfully!')
                // this.props.history.push({ pathname: "/" });
            })
            .catch((error) => {
                message.error(error.message)
            })
            .finally(() => {
                window.location.reload()
            })
    }

    onDocumentFinish = (values) => {
        const signers = []
        signers.push({
            id: 1,
            name: 'Patti Pan',
            email: 'pantian@revart.co',
            language: 'en',
            order: 1
        })
        for (let i = 0; i < values.signers.length; i++) {
            const artist = this.state.artists.filter((a) => {
                return this.capitalizeName(a.name) === values.signers[i]
            })
            const email = artist[0].email
            signers.push({
                id: i + 2,
                name: this.capitalizeName(artist[0].name),
                email: email,
                language: 'en',
                order: 2
            })
        }
        const param = {
            sandbox: 0,
            is_draft: 1,
            embedded: 1,
            title: values.title,
            message: 'New document for signing.',
            use_signer_order: 0,
            reminders: 1,
            require_all_signers: 1,
            custom_requester_name: '',
            custom_requester_email: '',
            redirect: 'http://localhost:3000/agreements',
            redirect_decline: 'http://localhost:3000/agreements',
            client: '',
            //"expires": 1494276966,
            embedded_signing_enabled: 1,
            flexible_signing: 0,
            use_hidden_tags: 0,
            files: [
                {
                    name: 'Agreement File',
                    file_id: values.file.file.response.fileID
                }
            ],
            signers: signers,
            fields: []
        }
        let request
        request = createDocument(param)
        request
            .then((response) => {
                message.success('Document upload successful').then(() => {
                })
                // let today = new Date();
                // const dd = String(today.getDate()).padStart(2, '0');
                // const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                // const yyyy = today.getFullYear();
                // today = yyyy + '-' + mm + '-' + dd;

                //store the documents
                for (let i = 0; i < values.signers.length; i++) {
                    const artist = this.state.artists.filter((a) => {
                        return this.capitalizeName(a.name) === values.signers[i]
                    })
                    const artistID = artist[0].artist_id
                    const param = {
                        title: values.title,
                        hash: response.data.document_hash,
                        claim_url: response.data.embedded_claim_url,
                        sign_url: response.data.signers[i + 1].embedded_signing_url,
                        revart_sign_url: response.data.signers[0].embedded_signing_url,
                        //date: today, //NEEDS THIS FIELD
                        is_signed: false,
                        is_signed_revart: false,
                        artist: parseInt(artistID)
                    }
                    let request = postArtistContract(param)
                    request
                        .then((response) => {
                        })
                        .catch((error) => {
                            message.error(error.message)
                        })
                }
                if (typeof eversignEmbeddedRequesting === 'undefined') {
                    return
                }

                eversignEmbeddedRequesting.open({
                    url: response.data.embedded_claim_url,
                    containerID: 'request_container',
                    width: 1000,
                    height: 800,
                    events: {
                        loaded: function () {
                        },
                        submit: function () {
                            //window.location.reload();
                        },
                        error: function () {
                        }
                    }
                })
            })
            .catch((error) => {
                message.error(error.message)
            })
    }

    fileUploadCustom = (options) => {
        const {onError, onSuccess, file, onProgress} = options
        console.log(onError) //Todo: add on error handle
        console.log(onProgress) //Todo: add on onProgress handle

        let request
        request = uploadFile(file)
        request
            .then(
                (response) => {
                    onSuccess({fileID: response.data.file_id})
                }
            )
            .catch((error) => {
                message.error(error.message)
                //onError();
            })
    }

    displayCreation = (admin) => {
        const formItemLayout = {
            labelCol: {
                xs: {span: 24},
                sm: {span: 2}
            },
            wrapperCol: {
                xs: {span: 24},
                sm: {span: 20}
            }
        }
        const formItemLayoutWithOutLabel = {
            wrapperCol: {
                xs: {span: 24, offset: 0},
                sm: {span: 20, offset: 2}
            }
        }
        if (admin) {
            return (
                <div style={{paddingTop: '20px'}}>
                    <Form colon={true} labelAlign='left' onFinish={this.onDocumentFinish}>
                        <Form.Item name='title' label=' Document Title'>
                            <Input/>
                        </Form.Item>
                        <Form.Item name='file' label='Document File'>
                            <Upload accept='.pdf, .docx' customRequest={this.fileUploadCustom} maxCount={1}>
                                <Button icon={<UploadOutlined/>}>Click to Upload</Button>
                            </Upload>
                        </Form.Item>
                        <Form.List
                            name='signers'
                            rules={[
                                {
                                    validator: async (_, signers) => {
                                        if (!signers) {
                                            return Promise.reject(new Error('Must have at least one signer'))
                                        }
                                    }
                                }
                            ]}
                        >
                            {(fields, {add, remove}, {errors}) => (
                                <>
                                    {fields.map((field, index) => (
                                        <Form.Item
                                            {...(index === 0 ? formItemLayout : formItemLayoutWithOutLabel)}
                                            label={index === 0 ? 'Signer' : ''}
                                            required={false}
                                            key={field.key}
                                        >
                                            <Form.Item
                                                {...field}
                                                validateTrigger={['onChange', 'onBlur']}
                                                rules={[
                                                    {
                                                        required: true,
                                                        whitespace: true,
                                                        message: "Please input signer's name or delete this field."
                                                    }
                                                ]}
                                                noStyle
                                            >
                                                <Select
                                                    showSearch
                                                    style={{width: '59%'}}
                                                    placeholder='Enter name'
                                                    optionFilterProp='children'
                                                    /*onChange={onChange}
                                                                              onFocus={onFocus}
                                                                              onBlur={onBlur}
                                                                              onSearch={onSearch}
                                                                              filterOption={(input, option) =>
                                                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                              }*/
                                                >
                                                    {this.state.artists.map((artist) => (
                                                        <Select.Option key={artist.artistID}
                                                                       value={this.capitalizeName(artist.name)}>
                                                            {this.capitalizeName(artist.name)}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                            {fields.length > 1 ? (
                                                <MinusCircleOutlined className='dynamic-delete-button'
                                                                     onClick={() => remove(field.name)}/>
                                            ) : null}
                                        </Form.Item>
                                    ))}
                                    <Form.Item>
                                        <Button type='dashed' onClick={() => add()} style={{width: '60%'}}
                                                icon={<PlusOutlined/>}>
                                            Add signer
                                        </Button>
                                        <Form.ErrorList errors={errors}/>
                                    </Form.Item>
                                </>
                            )}
                        </Form.List>
                        <Button type='primary' htmlType='submit'>
                            Submit
                        </Button>
                    </Form>
                    <p/>
                    <h4>(After submitting information above, finish preparing the document that appears below)</h4>
                    <div id='request_container'/>
                    <Row
                        justify='start'
                        style={{
                            padding: 16,
                            bottom: 0,
                            position: 'fixed',
                            zIndex: 1,
                            right: 16,
                            left: 16 + this.props.siderWidth,
                            backgroundColor: 'rgba(255,255,255,0.4)'
                        }}
                    >
                        <Col span={6} offset={8}>
                            <Button
                                onClick={(e) => {
                                    this.props.history.push({pathname: URL_AGREEMENTS})
                                }}
                                block
                                size='middle'
                                htmlType='submit'
                            >
                                Cancel
                            </Button>
                        </Col>
                    </Row>
                </div>
            )
        }
        return
    }

    render() {
        //https://revartcotest.eversign.com/document/ ... /sign
        return (
            <div>
                <Title level={2} style={{marginBottom: 20}}>
                    {this.props.new === true ? <FileAddOutlined/> : <EditOutlined/>}
                    {this.props.new === true ? ' New' : ' Edit'} Agreement
                </Title>
                {this.displayCreation(is_admin_user(this.props))}
            </div>
        )
    }
}

export default withRouter(NewAgreement)
